var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCubeError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 495,
    height: 506,
    viewBox: "0 0 495 506",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.927 453.818C121.927 453.818 121.75 453.845 121.677 453.803L73.1916 425.81C73.1916 425.81 73.1228 425.706 73.1991 425.685L121.675 397.682C121.675 397.682 121.851 397.655 121.924 397.697L170.41 425.69C170.41 425.69 170.478 425.795 170.402 425.815L121.927 453.818Z",
    fill: "url(#paint0_linear_168_85687)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6769 426.204C73.6769 426.204 73.6212 426.3 73.5731 426.272L25.2809 398.391C25.2809 398.391 25.1642 398.259 25.1438 398.183L25.1577 342.424C25.1577 342.424 25.2133 342.328 25.2615 342.356L73.5537 370.237C73.5537 370.237 73.6703 370.369 73.6907 370.445L73.6769 426.204Z",
    fill: "#999999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.797 426.274C73.797 426.274 73.6728 426.266 73.6766 426.204L73.6904 370.445C73.6904 370.445 73.7498 370.287 73.8156 370.228L122.097 342.337C122.097 342.337 122.222 342.344 122.218 342.406L122.204 398.165C122.204 398.165 122.145 398.324 122.079 398.382L73.797 426.274Z",
    fill: "#585858"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7918 370.214C73.7918 370.214 73.6157 370.241 73.5435 370.199L25.2513 342.318C25.2513 342.318 25.1828 342.214 25.2588 342.193L73.5407 314.302C73.5407 314.302 73.7167 314.275 73.789 314.317L122.081 342.198C122.081 342.198 122.15 342.302 122.074 342.322L73.7918 370.214Z",
    fill: "#CACACA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M374.815 451.473C374.815 451.473 373.919 457.321 373.924 451.347L192.707 346.721C192.707 346.721 192.43 346.367 192.695 346.325L356.251 272.185C356.251 272.185 356.871 272.155 357.142 272.312L538.359 376.937C538.359 376.937 538.636 377.292 538.371 377.333L374.815 451.473Z",
    fill: "url(#paint1_linear_168_85687)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M242.347 375.479C242.347 375.479 242.18 375.768 242.036 375.685L97.2893 292.116C97.2893 292.116 96.9395 291.721 96.8785 291.493L96.92 124.366C96.92 124.366 97.0868 124.077 97.2311 124.16L241.978 207.73C241.978 207.73 242.327 208.124 242.388 208.352L242.347 375.479Z",
    fill: "#999999"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M242.704 375.689C242.704 375.689 242.332 375.667 242.343 375.481L242.385 208.354C242.385 208.354 242.563 207.879 242.76 207.704L387.476 124.104C387.476 124.104 387.848 124.126 387.837 124.313L387.795 291.44C387.795 291.44 387.617 291.915 387.42 292.09L242.704 375.689Z",
    fill: "#585858"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M242.689 207.661C242.689 207.661 242.162 207.742 241.945 207.617L97.1986 124.047C97.1986 124.047 96.9931 123.736 97.2209 123.675L241.937 40.0757C241.937 40.0757 242.464 39.9952 242.681 40.1202L387.428 123.69C387.428 123.69 387.633 124.001 387.405 124.062L242.689 207.661Z",
    fill: "#CACACA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M187.196 289.37C187.196 289.37 187.141 289.464 187.094 289.437L140.067 261.934C140.067 261.934 139.954 261.804 139.935 261.73L140.253 207.256C140.253 207.256 140.308 207.162 140.355 207.189L187.382 234.692C187.382 234.692 187.495 234.822 187.515 234.896L187.196 289.37Z",
    fill: "url(#paint2_linear_168_85687)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_168_85687",
    x1: 138.255,
    y1: 438.014,
    x2: 71.5015,
    y2: 377.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACACA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACACA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_168_85687",
    x1: 427.903,
    y1: 406.16,
    x2: 193.015,
    y2: 169.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACACA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACACA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_168_85687",
    x1: 202.426,
    y1: 244.356,
    x2: 89.3841,
    y2: 289.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E42D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44649,
    stopColor: "#6A0F0F",
    stopOpacity: 0.880952
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958333,
    stopColor: "#380A0A",
    stopOpacity: 0.74
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCubeError);
export default __webpack_public_path__ + "static/media/CubeError.2c80b6acfd21e38c3a94b58e9180ac15.svg";
export { ForwardRef as ReactComponent };